<template>
  <Card shadow v>
    <p slot="title">
      重复IP列表
      <span class="card-small-title">(4日内重复ip会员)</span>
    </p>
    <table class="TB_COLLAPSE" width="100%">
      <thead>
        <tr>
          <th width="25%">ip</th>
          <th width="10%">重复站点数</th>
          <th width="15%">站点</th>
          <th>会员</th>
          <th>分公司</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in historyData" >
          <tr :key="item.ip">
            <td :rowspan="item.memname.length+1">{{ item.ip }}</td>
            <td :rowspan="item.memname.length+1">{{ item.ip_siterep_count }}</td>
          </tr>
          <tr v-for="mem, ind in item.memname" :key="ind+item.memname.length+item.ip">
            <td>{{ mem.site }}</td>
            <td>{{ `${mem.username} [ ${mem.memname} ]`}}</td>
            <td>{{ mem.l2name }}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <Page
      ref="pages"
      class="text-right mt-2"
      show-sizer
      show-total
      :current.sync="current"
      :total="dataCount"
      :page-size="pageSize"
      :page-size-opts="pageSizeOpts"
      @on-change="changepage"
      @on-page-size-change="changePageSize"
      :simple="false"
    >
      <span>
        <span
          v-t="{ path: 'common.pageTotal', args: { pageindex: pageindexStart, pageSize: pageindexEnd, total: dataCount }}"
        ></span>
      </span>
    </Page>
  </Card>
</template>
<script>
export default {
  name: 'IpReMem',
  data () {
    return {
      ipRelist: [],
      dataCount: 0,
      pageSizeOpts: [5, 10, 15, 20, 25, 30],
      pageSize: 30,
      pageindex: 1,
      historyData: [],
      current: 1,
      pageindexStart: 0,
      pageindexEnd: 0,
    }
  },
  created () {
    this.getIpReMem()
  },
  methods: {
    async getIpReMem () {
      try {
        const res = await this.$axios.iprepmem()

        this.ipRelist = res
        this.dataCount = res.length
        this.historyData = this.ipRelist
        this.pageindexStart = 1
        this.pageindexEnd = this.dataCount

      } catch (error) {
        console.log(error);
      }
    },
    changepage (index) {
      this.pageindex = index
      this.pageindexStart = (index - 1) * this.pageSize + 1;
      const _start = (index - 1) * this.pageSize;
      const _end = index * this.pageSize;
      this.historyData = this.ipRelist.slice(_start, _end);
      if (this.historyData.length == this.pageSize) {
        this.pageindexEnd = this.historyData.length * this.pageindex
      } else {
        this.pageindexEnd = this.dataCount
      }
    },
    changePageSize (value) {
      this.pageSize = value
      this.pageindex = 1
      this.changepage(this.pageindex)
    },
  }
}
</script>